<ng-container *ngIf="hasEverHadTasks">
  <div *ngIf="isOpen; else TasksFloatingButton" [class.elevated]="elevated">
    <div class="opened-tasks">
      <div class="header">
        <div class="left">
          <h1>{{ showHistory ? 'Toutes les demandes' : 'Résumé des demandes' }}</h1>
          <p>
            {{ showHistory ? 'Toutes les demandes effectuées.' : "Demandes en cours d'exécution." }}
          </p>
        </div>
        <div class="right">
          <app-button
            *ngIf="!showHistory"
            text="Toutes les demandes"
            btnType="text"
            (click)="showHistoryView()"
          ></app-button>
          <app-button *ngIf="showHistory" text="En cours" btnType="text" (click)="showRunningView()"> </app-button>
          <app-button text="Réduire" btnType="text" (click)="minimize()"> </app-button>
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading && tasks.length === 0" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Chargement des demandes...</p>
      </div>

      <!-- Empty State -->
      <div *ngIf="isEmpty && !isLoading" class="empty-container">
        <mat-icon>inbox</mat-icon>
        <p>{{ showHistory ? 'Aucune demande trouvée' : 'Aucune demande en cours' }}</p>
      </div>

      <!-- Tasks List -->
      <div *ngIf="!isEmpty && !isLoading" class="tasks-container" #tasksContainer (scroll)="onScroll($event)">
        <div *ngIf="isLoadingMore" class="loading-more">
          <mat-spinner diameter="24"></mat-spinner>
          <p>Chargement des demandes plus anciennes...</p>
        </div>

        <div class="task" *ngFor="let task of tasks">
          <div class="status" [ngClass]="task.status">
            @if (task.status === 'running' || task.status === 'queued') {
              <mat-spinner diameter="24"></mat-spinner>
            } @else {
              <mat-icon *ngIf="taskStatusConfig[task.status ?? 'default'].icon">{{
                taskStatusConfig[task.status ?? 'default'].icon
              }}</mat-icon>
            }
          </div>
          <div class="details">
            <div class="time">
              {{ isMultiHospital ? `${hospitalMap[task.hospital!]} - ` : '' }}{{ getRelativeTime(task.createdAt!) }}
            </div>
            <div class="tags" *ngIf="task.operation">
              <span>{{ tasksOperationLabels[task.operation] || task.operation }}</span>
              <span *ngIf="task.data.name">{{ task.data.name }}</span>
              <span *ngIf="task.data.startDate && task.data.endDate"
                >{{ task.data.startDate | date: 'd MMMM yyyy' : '' : 'fr' }} -
                {{ task.data.endDate | date: 'd MMMM yyyy' : '' : 'fr' }}</span
              >
            </div>
            <div class="status-details" *ngIf="(task.steps && task.steps.length) || task.error">
              {{
                task.status === 'failed'
                  ? task.error
                  : task.steps && task.steps.length
                    ? task.steps[task.steps.length - 1].name
                    : ''
              }}
            </div>
            <div class="time" *ngIf="task.status === 'succeeded'">Durée: {{ getTaskDuration(task) }}</div>

            <div class="progress-bar" *ngIf="task.steps && task.steps.length > 0 && task.status === 'running'">
              <div
                class="progress-fill"
                [style.width.%]="(task.steps[task.steps.length - 1].progress || 0) * 100"
              ></div>
            </div>
          </div>
          <div class="actions">
            <app-button
              *ngIf="task.status === 'succeeded'"
              [text]="resultButtonLabels[task.operation] || 'Afficher'"
              btnType="text"
              (click)="viewTaskResult(task)"
            >
            </app-button>
            <app-button
              *ngIf="task.status === 'failed' && retryableTasks.includes(task.operation)"
              text="Réessayer"
              btnType="text"
              (click)="retryTask(task)"
            >
            </app-button>
            <app-button *ngIf="task.status === 'queued'" text="Annuler" btnType="text" (click)="cancelTask(task)">
            </app-button>

            <app-button
              *ngIf="(task.status === 'succeeded' || task.status === 'failed') && !showHistory"
              [iconOnly]="true"
              icon="close"
              btnType="lite"
              color="black"
              (click)="dismissTask(task)"
            >
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #TasksFloatingButton>
    <div class="container" (click)="toggleOpen()" [class.elevated]="elevated">
      <div class="icon-container">
        <span class="count-tag" *ngIf="runningTasksCount > 0">{{ runningTasksCount }}</span>
        <mat-icon>text_snippet</mat-icon>
      </div>
    </div>
  </ng-template>
</ng-container>
